// :cow: Cosmose CONFIDENTIAL :iso:
import * as LanguageActions from './language.actions';
import { initialState, LanguageState } from './language.state';

export function reducer(
  state = initialState,
  action: LanguageActions.All,
): LanguageState {
  switch (action.type) {
    case LanguageActions.SET_LANGUAGE: {
      return {
        ...state,
        language: action.payload.language,
      };
    }
    default: {
      return {...state};
    }
  }
}
